import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fmt, previewSrc, CATEGORY_LABELS } from "../api";

export const ProductCard = ({ product, index = 0 }) => {
  const img = previewSrc((product.previews || [])[0]);
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.8, delay: (index % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link
        to={`/product/${product.slug}`}
        data-testid={`product-card-${product.slug}`}
        className="group block"
      >
        <div className="relative overflow-hidden rounded-[1.4rem] border border-sage/10 bg-white shadow-[0_10px_30px_-5px_rgba(59,87,75,0.05)] transition-shadow duration-500 group-hover:shadow-[0_20px_40px_-10px_rgba(59,87,75,0.15)]">
          <div className="aspect-[4/5] overflow-hidden">
            {img ? (
              <img
                src={img}
                alt={product.name}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.05]"
              />
            ) : (
              <div className="flex h-full items-center justify-center bg-lavender-tint font-serif text-lg italic text-lavender-deep">
                Preview coming soon
              </div>
            )}
          </div>
          {!product.purchasable && (
            <span className="absolute left-4 top-4 rounded-full bg-ink/80 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-cream" data-testid="product-unavailable-badge">
              Not yet available
            </span>
          )}
          {product.compare_at_price_cents > product.price_cents && (
            <span className="absolute right-4 top-4 rounded-full bg-lavender-deep px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-cream" data-testid="product-sale-badge">
              Sale
            </span>
          )}
          <span className="absolute bottom-4 right-4 flex h-10 w-10 items-center justify-center rounded-full bg-cream/90 text-sage opacity-0 backdrop-blur transition-all duration-500 group-hover:opacity-100">
            <ArrowUpRight size={18} />
          </span>
        </div>
        <div className="mt-4 flex items-start justify-between gap-3 px-1">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-lavender-deep">
              {CATEGORY_LABELS[product.category] || product.category}
            </p>
            <h3 className="mt-1 font-serif text-xl leading-snug text-ink transition-colors group-hover:text-sage">
              {product.name}
            </h3>
          </div>
          <div className="mt-1 text-right">
            {product.compare_at_price_cents > product.price_cents && (
              <p className="font-mono text-xs text-ink/40 line-through">
                {fmt(product.compare_at_price_cents, product.currency)}
              </p>
            )}
            <p className="font-mono text-sm text-sage-deep">{fmt(product.price_cents, product.currency)}</p>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
